export default {"src":"/_next/static/media/TaskCount.8b9e9b63.svg","height":26,"width":27,"blurWidth":0,"blurHeight":0};